import { Link as RouterLink } from 'react-router-dom';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import XIcon from '@mui/icons-material/X';
import { marketingLegalLinks, marketingNav } from '../../marketing/marketingNav';
import { useT } from '../../i18n/useT';
import MarketingNavLink from './MarketingNavLink';

const L = `${process.env.PUBLIC_URL || ''}/marketing-assets`;
const LOGO = `${L}/VisiMe_Logo_RGB-1.png`;

export default function MarketingFooter() {
  const t = useT();

  return (
    <footer className="landing-footer">
      <div className="l-wrap">
        <div className="landing-footer-grid">
          <div className="landing-footer-brand">
            <RouterLink to="/landing" className="landing-footer-logo" aria-label="VisiMe Startseite">
              <img src={LOGO} alt="" />
              <span>{t('brandName')}</span>
            </RouterLink>
            <p className="landing-footer-tag">Digitale Visitenkarte mit Standort. Für iOS und Android.</p>
            <div className="landing-social">
              <a href="https://facebook.com/visimeapp" target="_blank" rel="noopener noreferrer" aria-label={t('socialFacebookAria')}>
                <FacebookIcon sx={{ fontSize: 18 }} />
              </a>
              <a href="https://instagram.com/visimeapp" target="_blank" rel="noopener noreferrer" aria-label={t('socialInstagramAria')}>
                <InstagramIcon sx={{ fontSize: 18 }} />
              </a>
              <a href="https://twitter.com/visimeApp" target="_blank" rel="noopener noreferrer" aria-label={t('socialXAria')}>
                <XIcon sx={{ fontSize: 16 }} />
              </a>
            </div>
          </div>
          <nav className="landing-footer-col" aria-label="Navigation">
            <h2 className="landing-footer-heading">Navigation</h2>
            {marketingNav.map((item) => (
              <MarketingNavLink key={item.labelKey} item={item} />
            ))}
          </nav>
          <nav className="landing-footer-col" aria-label="Nützliche Links">
            <h2 className="landing-footer-heading">Nützliche Links</h2>
            {marketingLegalLinks.map((item) => (
              <RouterLink key={item.href} to={item.href}>
                {item.label}
              </RouterLink>
            ))}
          </nav>
          <div className="landing-footer-col">
            <h2 className="landing-footer-heading">Hilfe</h2>
            <RouterLink to="/support">FAQ &amp; Support</RouterLink>
          </div>
        </div>
        <div className="landing-footer-bottom">
          <span>VisiMe © {new Date().getFullYear()}</span>
          <span>Schweiz</span>
        </div>
      </div>
    </footer>
  );
}
